<template>
    <div class="invitaciones">
        <v-container class="my-1">
        <!--    Diálogo  Modal para mostrar mensaje Servicio Suspendido    -->
        <v-dialog v-model="dialogNopay" max-width="500">
            <v-card>
                <v-toolbar dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogNopay = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">
                    {{$t('servicio_suspendido')}}
                </v-card-title>
                <v-card-text align="left">
                    <p>
                        {{$t('msg_supendido')}}<br> <br>
                        <ul>
                            <li>{{$t('msg_supendido1')}}</li>
                            <li>{{$t('msg_supendido2')}}</li>
                        </ul><br>
                        {{$t('msg_supendido3')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined @click="dialogNopay = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
            <!--     Dialog para Mostrar mensaje "Seleccionar al menos un día de la Semana"       -->
            <v-dialog
                    v-model="dialog_at_least_one_day"
                    max-width="290"
            >
                <v-card>
                    <v-card-title class="headline">
                        {{$t('aviso')}}
                    </v-card-title>

                    <v-card-text>
                        {{$t('msg_no_days')}}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                                color="primary"
                                @click="dialog_at_least_one_day = false"
                        >
                            {{$t('aceptar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--     Dialog para Mostrar mensaje de Error      -->
            <v-dialog
                    v-model="dialogMsgError"
                    max-width="290"
            >
                <v-card>
                    <v-card-title class="headline">
                        {{$t('aviso')}}
                    </v-card-title>

                    <v-card-text>
                        {{msgError}}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                                color="primary"
                                @click="dialogMsgError = false"
                        >
                            {{$t('aceptar')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-form
                            v-model="valid"
                            v-on:submit.prevent="validate()"
                            ref="form"
                    >
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('add_new_contact') }}
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-switch
                                v-model="switch1"
                                @change="ChangeBands"
                                :label="switch1 ? $t('celular') :'E-mail'"
                            ></v-switch>
                            <vue-phone-number-input
                                    v-show="switch1"
                                    default-country-code="MX"
                                    color="#D32F2F"
                                    valid-color="#2196F3"
                                    @update="onChange"
                                    v-model="celular_nuevo"
                                    :only-countries="countries"
                                    :translations="custom_cell_phone"
                            >
                            </vue-phone-number-input>
                            <v-text-field
                                v-show="!switch1"
                                v-model="new_contact_email"
                                prepend-icon="email"
                                name="new_contact_email"
                                label="E-Mail"
                                :rules="emailRules"
                            >
                            </v-text-field>
                            <!--<v-text-field-->
                            <!--autofocus-->
                            <!--v-model="celular_nuevo"-->
                            <!--prepend-icon="phone_iphone"-->
                            <!--name="celular_nuevo"-->
                            <!--:label="$t('celular')"-->
                            <!--counter="10"-->
                            <!--maxlength="10"-->
                            <!--:rules="[rules.required, rules.counter, rules.number]"-->
                            <!--&gt;-->
                            <!--</v-text-field>-->
                            <v-spacer/>
                            <v-alert
                                    :value="bandYourself"
                                    type="error"
                            >
                                {{$t('msg_invitation_yourself')}}
                            </v-alert>
                            <v-alert
                                    :value="bandUserDisabled"
                                    type="error"
                            >
                                {{$t('msg_invitation_user_disabled')}}
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog = false"
                            >{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-card width="900" class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('Invitacion')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                                @submit.prevent="band_invitacion_empresarial ? alta_invitacion_empresarial() : alta_invitacion()"
                        >
                            <v-container>
                                <v-layout row wrap>
                                    <v-flex class="mt-0 mb-0 pt-0 pb-0" xs12 sm4 v-show="!band_vip_invitacion">
                                        <v-checkbox
                                                prepend-icon="business"
                                                v-model="band_invitacion_empresarial"
                                                name="band_invitacion_empresarial"
                                                :label="$t('lbl_invit_empresarial')"
                                                @change="changeCheck()"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex class="mt-0 mb-0 pt-0 pb-0" xs12 sm4 v-show="!band_vip_invitacion && (getProfile.roll !== 4 || (getProfile.roll === 4 && band_invitacion_empresarial === false))">
                                        <v-checkbox
                                                prepend-icon="update"
                                                v-model="band_invitacion_recurrente"
                                                name="band_invitacion_recurrente"
                                                :label="$t('lbl_invitacion_recurrente')"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex class="mt-0 mb-0 pt-0 pb-0" xs12 sm4 v-show="getProfile.roll === 5">
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{on}">
                                          <span v-on="on">
                                            <v-checkbox
                                                      prepend-icon="local_activity"
                                                      v-model="band_vip_invitacion"
                                                      name="band_vip_invitacion"
                                                      :label="$t('lbl_VIP_invitation')"
                                                      @change="changeCheck2()"
                                              >
                                              </v-checkbox>
                                          </span>
                                        </template>
                                        <span>{{$t('tooltip_vip_invitation')}}</span>
                                      </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="!band_invitacion_empresarial" disable>
                                    <v-flex>
                                        <v-card color="blue-grey lighten-4">
                                            <v-tooltip right>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                            fab
                                                            color="primary"
                                                            top
                                                            left
                                                            relative
                                                            v-on="on"
                                                            @click="dialog = !dialog, celular_nuevo = '', band_cellphone = false, bandYourself = false, bandUserDisabled = false, switch1 = true, new_contact_email = '', valid = false"
                                                    >
                                                        <v-icon>person_add</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{$t('add_new_contact')}}</span>
                                            </v-tooltip>
                                            <v-card-text>
                                                <v-autocomplete
                                                        v-model="email"
                                                        :items="items"
                                                        multiple
                                                        return-object
                                                        chips
                                                        prepend-icon="email"
                                                        :loading="isLoading"
                                                        :search-input.sync="search"
                                                        :item-text="fullNamePlusCellphone"
                                                        :item-value="celularAndEmail"
                                                        :placeholder="$t('placeholder_invitados2')"
                                                        :label="$t('invitados')"
                                                        :error-messages="errores.guests"
                                                        :no-data-text="$t('no_resultados')"
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                                :selected="data.selected"
                                                                close
                                                                class="chip--select-multi"
                                                                @input="remove(data.item)"
                                                        >
                                                            <v-avatar>
                                                                <img :src="data.item.avatar">
                                                            </v-avatar>
                                                            {{ data.item.first_name }} {{data.item.last_name}}
                                                        </v-chip>
                                                    </template>
                                                    <template v-slot:item="data">
                                                        <template v-if="typeof data.item !== 'object'">
                                                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                                        </template>
                                                        <template v-else>
                                                            <v-list-tile-avatar>
                                                                <img :src="data.item.avatar">
                                                            </v-list-tile-avatar>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-tile-title>
                                                                <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                                            </v-list-tile-content>
                                                        </template>
                                                    </template>
                                                </v-autocomplete>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex
                                            xs12 sm6
                                            v-if="band_invitacion_empresarial" disable
                                    >
                                        <v-autocomplete
                                                v-model="id_empresa_empresarial"
                                                :items="items"
                                                prepend-icon="business"
                                                :loading="isLoading_empresas"
                                                :search-input.sync="search"
                                                item-text="name"
                                                item-value="id"
                                                box
                                                :placeholder="$t('placeholder_empresas')"
                                                :label="$t('Empresa')"
                                                :error-messages="errores.id_empresa"
                                                :no-data-text="$t('no_resultados')"
                                                @input="get_managerByCompany(id_empresa_empresarial)"
                                                clearable
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                        :selected="data.selected"
                                                        class="chip--select-multi"
                                                >
                                                    {{ data.item.name }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                {{ data.item.name }}
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6
                                            v-if="band_invitacion_empresarial" disable
                                    >
                                        <v-autocomplete
                                                v-show="id_empresa_empresarial !== null"
                                                v-model="admin"
                                                prepend-icon="email"
                                                name="admin"
                                                box
                                                return-object
                                                item-text="first_name"
                                                item-value="email"
                                                :label="$t('email_admin')"
                                                :filter="customFilterAdministradores"
                                                :error-messages="errores.referredMail"
                                                :items="administradores"
                                                :no-data-text="$t('no_resultados')"
                                                clearable
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                        :selected="data.selected"
                                                        class="chip--select-multi"
                                                >
                                                    {{data.item.email}}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                {{data.item.first_name}} {{ data.item.last_name}} - {{data.item.email}}
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-alert
                                            :value="bandSinAdministrador === true && band_invitacion_empresarial === true"
                                            type="error"
                                            outline
                                            transition="scale-transition"
                                    >
                                        {{$t('msg_no_manager_found')}}
                                    </v-alert>
                                </v-layout>
                                <v-layout row wrap v-if="!band_invitacion_empresarial && getProfile.roll !== 4">
                                  <v-flex xs12 sm3>
                                    <v-checkbox
                                        v-model="checkCC"
                                        :label="$t('share_with')"
                                    >
                                    </v-checkbox>
                                  </v-flex>
                                  <v-flex xs12 sm9>
                                    <v-autocomplete
                                        v-if="checkCC"
                                        v-model="hostCC"
                                        box
                                        prepend-icon="forward_to_inbox"
                                        name="hostCC"
                                        :item-text="fullName"
                                        item-value="id"
                                        :label="$t('Empleado')"
                                        :filter="customFilterUsersLessMe"
                                        :error-messages="errores.host_cc"
                                        :items="usersLessMe"
                                        :no-data-text="$t('no_resultados')"
                                        multiple
                                        chips
                                        clearable
                                    >
                                    </v-autocomplete>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="band_invitacion_recurrente" disable>
                                    <v-flex xs12 sm6>
                                        <v-label>{{ $t('lbl_selecciona_dias') }}</v-label>
                                        <v-container fluid grid-list-sm>
                                            <v-layout row wrap>
                                                <v-checkbox
                                                        v-model="Lunes"
                                                        :label="$t('Lunes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Martes"
                                                        :label="$t('Martes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Miercoles"
                                                        :label="$t('Miercoles')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Jueves"
                                                        :label="$t('Jueves')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Viernes"
                                                        :label="$t('Viernes')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Sabado"
                                                        :label="$t('Sabado')"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="Domingo"
                                                        :label="$t('Domingo')"
                                                ></v-checkbox>
                                                <!--</v-flex>-->
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-menu
                                                v-if="band_invitacion_recurrente"
                                                v-model="modal2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="dateInv"
                                                        :label="$t('fecha_inv')"
                                                        prepend-icon="event"
                                                        :error-messages="errores.dateInv"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    v-model="dateInv"
                                                    :min="get_current_date()"
                                                    :locale="$t('region')"
                                                    @input="modal2 = false"
                                            ></v-date-picker>
                                        </v-menu>
                                        <v-menu
                                                v-model="modal_fecha_expiracion"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="diary"
                                                        :label="$t('fecha_expiracion')"
                                                        prepend-icon="event"
                                                        :error-messages="errores.expiration"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    v-model="diary"
                                                    :min="get_current_date()"
                                                    :locale="$t('region')"
                                                    @input="modal_fecha_expiracion = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6  v-show="getProfile.roll !== 4">
                                        <v-autocomplete
                                                v-model="areaId"
                                                prepend-icon="location_city"
                                                name="areaId"
                                                item-text="nombre"
                                                item-value="id"
                                                :label="$t('Area')"
                                                :filter="customFilterArea"
                                                :error-messages="errores.areaId"
                                                :items="areas"
                                                :no-data-text="$t('no_resultados')"
                                                @change="refillDocumnetation"
                                                clearable
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                        :selected="data.selected"
                                                >
                                                    <v-icon
                                                            x-large
                                                            :color="data.item.color"
                                                    >
                                                        label
                                                    </v-icon>
                                                    {{ data.item.nombre }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-icon
                                                        x-large
                                                        :color="data.item.color"
                                                >
                                                    label
                                                </v-icon>
                                                {{data.item.nombre}}
                                            </template>
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-menu
                                                v-if="!band_invitacion_recurrente && !band_vip_invitacion"
                                                v-model="modal2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="dateInv"
                                                        :label="$t('fecha_inv')"
                                                        prepend-icon="event"
                                                        :error-messages="errores.dateInv"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    v-model="dateInv"
                                                    :min="get_current_date()"
                                                    :locale="$t('region')"
                                                    @input="modal2 = false"
                                            ></v-date-picker>
                                        </v-menu>
                                        <v-menu
                                                v-if="!band_vip_invitacion"
                                                ref="menu"
                                                v-model="menu2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="hora"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="hora"
                                                        :label="$t('hora_inv')"
                                                        prepend-icon="access_time"
                                                        :error-messages="errores.timeInv"
                                                        readonly
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                    v-if="menu2"
                                                    v-model="hora"
                                                    format="24hr"
                                                    full-width
                                                    @click:minute="$refs.menu.save(hora)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-textarea
                                                v-model="subject"
                                                prepend-icon="subject"
                                                name="subject"
                                                :placeholder="$t('placeholder_asunto')"
                                                :label="$t('Asunto')"
                                                :counter="150"
                                                :maxlength="150"
                                                :error-messages="errores.subject"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 sm6 v-if="!band_vip_invitacion">
                                        <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                                        <v-radio-group
                                                v-model="vehicle"
                                                prepend-icon="directions_car"
                                                name="vehicle"
                                                :mandatory="false"
                                                :error-messages="errores.vehicle"
                                        >
                                            <v-radio :label="$t('Si')" value=true></v-radio>
                                            <v-radio label="No" value=false></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-textarea
                                                v-model="notes"
                                                prepend-icon="notes"
                                                name="notes"
                                                :placeholder="$t('placeholder_notas')"
                                                :label="$t('Notas')"
                                                :counter="256"
                                                :maxlength="256"
                                                :error-messages="errores.notes"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 sm6 v-if="!band_vip_invitacion">
                                        <v-checkbox
                                                v-model="multiple_accesses"
                                                prepend-icon="fact_check"
                                                name="multiple_accesses"
                                                :label="$t('multiple_accesses')"
                                                :error-messages="errores.multiple_accesses"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                    </v-flex>
                                    <v-flex xs12 sm6 v-show="documentationsByCompany.length > 0">
                                        <div class="subheading mb-2">Documentos adicionales</div>
                                        <div class="text mb-2">* Documentos requeridos para validación</div>
                                        <v-layout row wrap>
                                            <v-flex v-for="doc in documentationsByCompany" :key="doc.id" xs6>
                                            <v-checkbox
                                                v-model="documentos"
                                                :label="doc.name"
                                                :value="doc.id"
                                                hide-details
                                                dense
                                            ></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                                <v-btn
                                        :loading="loading"
                                        color="primary"
                                        type="submit">
                                    {{$t('enviar')}}
                                </v-btn>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import {mapGetters, mapState} from 'vuex'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)

    export default {
        name: "invitacion_tab_empleado",
        data () {
            return {
                rules: {
                    required: value => !!value || 'Campo Requerido',
                    counter: value => value.length >= 10 || 'El Número de Celular debe de contener 10 dígitos',
                    number: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Ingresa un Campo Númerico.'
                    },
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Dirección E-Mail no Válida.'
                    },
                },
                emailRules: [
                  v => !!v || 'E-mail es Requerido',
                  v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Dirección E-Mail no Válida.',
                ],
                //Controles TAB
                tab: null,
                icons: true,
                centered: true,
                grow: true,
                vertical: false,
                prevIcon: false,
                nextIcon: true,
                right: false,
                tabs: 1,
                //Controles TAB
                //Campos formulario
                alerta: false,
                update: false,
                id_update: 0,
                nombre: '',
                activa: '',
                id_empresa: '',
                areaId: '',
                errores: [],
                areas: [],
                documentationsByCompany: [],
                documentationsByArea: [],
                documentationsByCompanyOriginal: [],
                documentos: [],
                documentosPorArea: [],
                calendario: false,
                hora: '',
                dateInv:'',
                diary: '',
                vehicle: 'false',
                // sec_equip: [],
                equipo: [],
                modal2: false,
                modal_fecha_expiracion: false,
                menu2: false,
                email: [],
                headers: [
                    {
                        text: 'Modificar',
                        align: 'left',
                        sortable: false,
                        value: 'update'
                    },
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: true,
                        value: 'id'
                    },
                    {
                        text: 'Nombre',
                        align: 'left',
                        sortable: true,
                        value: 'nombre'
                    },
                    {
                        text: 'Activa',
                        align: 'left',
                        sortable: true,
                        value: 'activa'
                    }
                ],
                casetas: [],
                subject: '',
                notes: '',
                multiple_accesses: false,
                companyFrom: '',
                cellNumber: '',
                id_empleado: '',
                loading: false,
                descriptionLimit: 60,
                entries: [],
                entries2: [],
                isLoading: false,
                isLoading_empresas: false,
                search: null,
                guests: null,
                dialog: false,
                celular_nuevo: '',
                areaId2: '',
                modal22: false,
                dateInv2: '',
                menu22: false,
                hora2: '',
                subject2: '',
                vehicle2: 'false',
                notes2: '',
                companyFrom2: '',
                email2: [],
                people: [],
                grupos: [],
                contactosXgrupo:[],
                isUpdating: false,
                id_empresa_empresarial:'',
                band_invitacion_empresarial: false,
                admin: {},
                administradores: [],
                band_invitacion_recurrente: false,
                band_vip_invitacion: false,
                Lunes: false,
                Martes: false,
                Miercoles: false,
                Jueves: false,
                Viernes: false,
                Sabado: false,
                Domingo: false,
                dias: '',
                dialog_at_least_one_day: false,
                custom_cell_phone: { },
                band_cellphone: false,
                band_email: false,
                countries: ['MX', 'US'],
                cellphone_plus_country_code: '',
                dialogMsgError: false,
                msgError: '',
                bandSinAdministrador: false,
                dialogNopay: false,
                bandUserDisabled: false,
                bandYourself: false,
                usersLessMe: [],
                checkCC: false,
                switch1: true,
                new_contact_email: '',
                valid: false,
                hostCC: [],
                mensaje: '',
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language']),
            fields () {
                if(this.band_invitacion_empresarial){
                    if (!this.id_empresa_empresarial) return []

                    return Object.keys(this.id_empresa_empresarial).map(key => {
                        return {
                            key,
                            value: this.id_empresa_empresarial[key] || 'n/a'
                        }
                    })
                    console.log('Se activo....')
                }
                else{
                    if (!this.email) return []

                    return Object.keys(this.email).map(key => {
                        return {
                            key,
                            value: this.email[key] || 'n/a'
                        }
                    })
                }
            },
            items () {
                if(this.band_invitacion_empresarial){
                    return this.entries2.map(entry => {
                        const name = entry.name.length > this.descriptionLimit
                            ? entry.name.slice(0, this.descriptionLimit) + '...'
                            : entry.name

                        return Object.assign({}, entry, { name })
                    })
                }
                else {
                    return this.entries.map(entry => {
                        const email = entry.email.length > this.descriptionLimit
                            ? entry.email.slice(0, this.descriptionLimit) + '...'
                            : entry.email

                        return Object.assign({}, entry, { email })
                    })
                }
            }
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            email (val) {
                if (val && val.length > 0) {
                    this.search = null
                }
            },
            search (val) {
                console.log(val)
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
                if (val !== null && val !== undefined) {
                    if (this.band_invitacion_empresarial) {
                        if (val.length > 2) {

                            this.isLoading_empresas = true

                            // Lazily load input items
                            const config = {
                                method: 'get',
                                url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': 'Token ' + store.getters.getToken
                                }
                            };
                            axios(config)
                                .then(response => {
                                    console.log(response.data)
                                    if (this.entries2.length > 0) {
                                        for (var i = 0; i < response.data.length; i++) {
                                            this.entries2.push(response.data[i])
                                        }
                                    } else
                                        this.entries2 = response.data
                                })
                                .catch(error => {
                                    console.log(error)
                                })
                                .finally(() => (this.isLoading_empresas = false))
                        }
                    } else {
                        if (val.length > 2) {

                            this.isLoading = true

                            // Lazily load input items
                            const config = {
                                method: 'get',
                                url: 'https://empresa-service.intrare.app/users/filter?search=' + val,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': 'Token ' + store.getters.getToken
                                }
                            };
                            axios(config)
                                .then(response => {
                                    console.log(response.data)
                                    if (this.entries.length > 0) {
                                        for (var i = 0; i < response.data.length; i++) {
                                            this.entries.push(response.data[i])
                                        }
                                    } else
                                        this.entries = response.data
                                })
                                .catch(error => {
                                    console.log(error)
                                })
                                .finally(() => (this.isLoading = false))
                        }
                    }
                }
            }
        },
        created: function(){
            this.get_areas()
            this.getUsersLessMe()
            // this.get_equipment()
            this.get_grupos()
            this.getDocumentationByCompany()
        },
        beforeUpdate () {
            this.custom_cell_phone = {
                "countrySelectorLabel": this.$t('codigo_pais'),
                "phoneNumberLabel": this.$t('celular'),
                "example": this.$t('ejemplo')
            }
        },
        methods: {
            refillDocumnetation(valorSeleccionado) {
                console.log('Área seleccionada:', valorSeleccionado)
                // Quitar los documentos autoseleccionados por el área anterior
                if (this.documentosPorArea.length > 0) {
                    this.documentos = this.documentos.filter(docId => !this.documentosPorArea.includes(docId))
                    this.documentosPorArea = []
                }
                if (valorSeleccionado !== null && valorSeleccionado !== undefined) {
                    this.get_documentacion_area(valorSeleccionado)
                } else {
                    this.documentationsByCompany = [...this.documentationsByCompanyOriginal]
                }
            },
            ChangeBands () {
                this.bandUserDisabled = false
                this.bandYourself = false
            },
            fullName: item => item.first_name + ' ' + item.last_name +' - ' + item.email,
            searchNewCellphone (val) {
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/usersAll/filter?search=' + val,
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                }
              }
              axios(config)
                .then(response => {
                  // console.log(response.data)
                  if (this.entries.length > 0) {
                    for (var i = 0; i < response.data.length; i++) {
                      if (response.data[0].is_active === true)
                        this.entries.push(response.data[i])
                    }
                  } else
                  {
                    if (response.data.length >0 && response.data[0].is_active === true)
                      this.entries = response.data
                  }
                  if(response.data.length > 0) {
                    if (response.data[0].is_active === true) {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.cellphone_plus_country_code ===  this.email[i].celular)
                          band = true
                      }
                      if (!band) {
                        this.email.push(
                          {
                            "first_name": this.cellphone_plus_country_code,
                            "last_name": '',
                            "email": response.data[0].email,
                            "celular": this.cellphone_plus_country_code
                          }
                        )
                      }
                      this.dialog = false
                    } else if (response.data[0].is_active === false && response.data[0].temporalToken !== null) {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.cellphone_plus_country_code ===  this.email[i].celular)
                          band = true
                      }
                      if (!band) {
                        this.entries.push(
                          {
                            "first_name": this.cellphone_plus_country_code,
                            "last_name": '',
                            "email": '',
                            "celular": this.cellphone_plus_country_code
                          }
                        )
                        this.email.push(
                          {
                            "first_name": this.cellphone_plus_country_code,
                            "last_name": '',
                            "email": '',
                            "celular": this.cellphone_plus_country_code
                          }
                        )
                      }
                      this.dialog = false
                    } else{
                      this.bandUserDisabled = true
                    }
                  } else {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.cellphone_plus_country_code ===  this.email[i].celular)
                          band = true
                      }
                      if (!band) {
                        this.entries.push(
                          {
                            "first_name": this.cellphone_plus_country_code,
                            "last_name": '',
                            "email": '',
                            "celular": this.cellphone_plus_country_code
                          }
                        )
                        this.email.push(
                          {
                            "first_name": this.cellphone_plus_country_code,
                            "last_name": '',
                            "email": '',
                            "celular": this.cellphone_plus_country_code
                          }
                        )
                      }
                    this.dialog = false
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            },
            searchNewEmail (val) {
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/usersAll/filter?search=' + val,
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                }
              }
              axios(config)
                .then(response => {
                  // console.log(response.data)
                  if (this.entries.length > 0) {
                    for (var i = 0; i < response.data.length; i++) {
                      if (response.data[0].is_active === true)
                        this.entries.push(response.data[i])
                    }
                  } else
                  {
                    if (response.data.length > 0 && response.data[0].is_active === true) {
                      this.entries = response.data
                    }
                  }
                  if(response.data.length > 0) {
                    if (response.data[0].is_active === true) {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.new_contact_email ===  this.email[i].email)
                          band = true
                      }
                      if (!band) {
                        this.email.push(
                          {
                            "first_name": 'Usuario',
                            "last_name": 'Nuevo',
                            "email": this.new_contact_email,
                            "celular": response.data[0].celular
                          }
                        )
                      }
                      this.dialog = false
                    } else if (response.data[0].is_active === false && response.data[0].temporalToken !== null) {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.new_contact_email ===  this.email[i].email)
                          band = true
                      }
                      if (!band) {
                        this.entries.push(
                          {
                            "first_name": this.new_contact_email,
                            "last_name": '',
                            "email": this.new_contact_email,
                            "celular": ''
                          }
                        )
                        this.email.push(
                          {
                            "first_name": this.new_contact_email,
                            "last_name": '',
                            "email": this.new_contact_email,
                            "celular": ''
                          }
                        )
                      }
                      this.dialog = false
                    } else{
                      this.bandUserDisabled = true
                    }
                  } else {
                      let band = false
                      for (let i = 0; i < this.email.length && !band; i++) {
                        if(this.new_contact_email ===  this.email[i].email)
                          band = true
                      }
                      if (!band) {
                        this.entries.push(
                          {
                            "first_name": this.new_contact_email,
                            "last_name": '',
                            "email": this.new_contact_email,
                            "celular": ''
                          }
                        )
                        this.email.push(
                          {
                            "first_name": this.new_contact_email,
                            "last_name": '',
                            "email": this.new_contact_email,
                            "celular": ''
                          }
                        )
                      }
                    this.dialog = false
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            },
            validate () {
                this.bandUserDisabled = false
                this.bandYourself = false
                if (this.band_cellphone === true && this.switch1 === true) {
                    if (this.getProfile.celular === this.cellphone_plus_country_code){
                      this.bandYourself = true
                      // console.log('Números de Celulares iguales')
                    } else {
                      // console.log('Diferente Número de Celular')
                      this.add_new_contact()
                    }
                }
                if (this.valid === true && this.switch1 === false) {
                    if (this.getProfile.email === this.new_contact_email){
                      this.bandYourself = true
                      // console.log('Números de Celulares iguales')
                    } else {
                      // console.log('Diferente Número de Celular')
                      this.add_new_contact_email()
                    }
                }
            },
            onChange (data) {
                console.log(data.formattedNumber)
                this.cellphone_plus_country_code = data.formattedNumber
                this.band_cellphone = data.isValid
            },
            get_grupos: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.grupos = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_contactosXgrupo: async function (id_grupo){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/grupos/contacts_grupos/' + id_grupo,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.contactosXgrupo = response.data
                        // console.log(this.contactosXgrupo)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            delay() {
                return new Promise(resolve => setTimeout(resolve, 1000));
            },
            fill_people: async function (){
                this.people = []
                this.isUpdating = true
                // console.log('GRUPOS')
                // console.log(this.grupos)
                for(let group of this.grupos){
                    // console.log(i.id)
                    this.people.push(
                        {
                            "header": group.nombre
                        }
                    )
                    await this.get_contactosXgrupo(group.id)
                    await this.delay()
                    for(let contact of this.contactosXgrupo){
                        // console.log(contact.email_usuario)
                        this.people.push(
                            {
                                "email_usuario": contact.email_usuario,
                                "Grupo": group.nombre,
                                "avatar_usuario": contact.avatar_usuario
                            }
                        )
                    }
                    this.people.push({ divider: true })
                }
                // console.log('PEOPLE')
                // console.log(this.people)
            },
            removePeople (item) {
                console.log(this.email2)
                const index = this.email2.indexOf(item.email_usuario)
                if (index >= 0) this.email2.splice(index, 1)
            },
            get_areas: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.areas = response.data
                        this.id_empresa = response.data[0].id_empresa
                        console.log(this.id_empresa)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            getDocumentationByCompany: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.documentationsByCompany = response.data
                        // Guardar una copia de los documentos originales de la empresa
                        this.documentationsByCompanyOriginal = [...response.data]
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_documentacion_area (idArea) {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getDocumentationByArea/' + idArea + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.documentationsByArea = response.data
                        
                        // Siempre mostrar todos los documentos disponibles de la empresa
                        this.documentationsByCompany = [...this.documentationsByCompanyOriginal]
                        
                        // Si el área tiene documentos, AGREGAR los del área a los ya seleccionados
                        if (this.documentationsByArea.length > 0) {
                            const documentosDelArea = this.documentationsByArea.map(doc => doc.idDocumentation)
                            console.log('documentos del área:', documentosDelArea)
                            
                            // Registrar qué documentos fueron autoseleccionados por esta área
                            this.documentosPorArea = []
                            // Agregar cada documento del área si no está ya seleccionado
                            documentosDelArea.forEach(docId => {
                                if (!this.documentos.includes(docId)) {
                                    this.documentos.push(docId)
                                    this.documentosPorArea.push(docId)
                                }
                            })
                                                    }
                        // Si no hay documentos del área, no se hace nada (se mantienen los seleccionados)
                        
                    })
                    .catch(error => {
                        console.log('Error al obtener documentos del área:', error)
                    })

            },
            getUsersLessMe (){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/users_less_me/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.usersLessMe = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            get_equipment: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.sec_equip = []
                        for(var i= 0; i < response.data.length; i++){
                            var algo = {
                                "id": response.data[i].id,
                                "nombre": response.data[i].nombre,
                                "selected": false
                            }
                            this.sec_equip.push(algo)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            add_new_contact(){
              this.searchNewCellphone(this.cellphone_plus_country_code)
            },
            add_new_contact_email(){
              this.searchNewEmail(this.new_contact_email)
            },
            get_guests(){
                this.guests= []
                // console.log('ENTRIES')
                // console.log(this.entries)
                // console.log('EMAIL')
                // console.log(this.email)
                for(var j = 0; j < this.email.length; j++){
                    for(var i = 0; i < this.entries.length; i++){
                        //Compara Número de Celular
                        if(this.entries[i].celular === this.email[j].celular && this.entries[i].email.length > 0 && this.entries[i].celular.length > 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j].celular)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        if(this.entries[i].celular === this.email[j].celular && this.entries[i].email.length === 0 && this.entries[i].celular.length > 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j].celular)
                            this.guests.push(
                                {
                                    "email": null,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        if(this.entries[i].celular === this.email[j].celular && this.entries[i].email.length > 0 && this.entries[i].celular.length > 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j].celular)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        if(this.entries[i].celular === this.email[j].celular && this.entries[i].email.length === 0 && this.entries[i].celular.length > 0){
                            console.log(this.entries[i].celular, ' == ', this.email[j].celular)
                            this.guests.push(
                                {
                                    "email": null,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        //Compara Emails
                        if(this.entries[i].email === this.email[j].email && this.entries[i].celular.length > 0 && this.entries[i].email.length > 0){
                            console.log(this.entries[i].email, ' == ', this.email[j].email)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        if(this.entries[i].email === this.email[j].email && this.entries[i].celular.length === 0 && this.entries[i].email.length > 0){
                            console.log(this.entries[i].email, ' == ', this.email[j].email)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": null
                                }
                            )
                            break
                        }
                        if(this.entries[i].email === this.email[j].email && this.entries[i].celular.length > 0 && this.entries[i].email.length > 0){
                            console.log(this.entries[i].email, ' == ', this.email[j].email)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": this.entries[i].celular
                                }
                            )
                            break
                        }
                        if(this.entries[i].email === this.email[j].email && this.entries[i].celular.length === 0 && this.entries[i].email.length > 0){
                            console.log(this.entries[i].email, ' == ', this.email[j].email)
                            this.guests.push(
                                {
                                    "email": this.entries[i].email,
                                    "cellphone": null
                                }
                            )
                            break
                        }
                    }
                }
                // console.log('GUESTS')
                // console.log(this.guests)
            },
            get_days(){
                this.dias = ''

                if(this.Lunes)
                    this.dias = '0'
                if(this.Martes)
                    this.dias += '1'
                if(this.Miercoles)
                    this.dias += '2'
                if(this.Jueves)
                    this.dias += '3'
                if(this.Viernes)
                    this.dias += '4'
                if(this.Sabado)
                    this.dias += '5'
                if(this.Domingo)
                    this.dias += '6'

            },
            at_least_one_day(){
                var count = 0

                if(this.Lunes)
                    count ++
                if(this.Martes)
                    count ++
                if(this.Miercoles)
                    count ++
                if(this.Jueves)
                    count ++
                if(this.Viernes)
                    count ++
                if(this.Sabado)
                    count ++
                if(this.Domingo)
                    count ++
                return count
            },
            alta_invitacion: function () {
                console.log('CC = ', this.hostCC)
                // console.log('DATOS EMPRESARIAL')
                // console.log(this.id_empresa_empresarial)
                console.log('ENTRIES = ', this.entries)
                console.log('EMAILS = ', this.email)
                this.get_guests()
                // console.log('GUESTS = ', this.guests)
                // for(var a = 0; a < this.guests.length ; a ++){
                //     console.log(this.guests[a].email)
                // }
                // console.log(this.dateInv)
                // console.log(this.hora)
                if(this.band_invitacion_recurrente && this.at_least_one_day() === 0) {
                    this.dialog_at_least_one_day = true
                }
                else{
                    this.loading = true
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.errores = []
                            if (this.guests === undefined || this.guests.length === 0) {
                                this.guests = null
                            }
                            var fecha_expiracion = this.dateInv
                            var dias_semana = ''
                            var tipo_invitacion = 0
                            if (this.band_invitacion_recurrente) {
                                this.get_days()
                                fecha_expiracion = this.diary
                                dias_semana = this.dias
                                tipo_invitacion = 2
                            }
                            var data = {}
                            data['guests'] = this.guests,
                            data['cellNumber'] = this.cellNumber,
                            data['areaId'] = this.areaId
                            data['dateInv'] = this.get_current_date()
                            data['timeInv'] = '13:00'
                            data['subject'] = this.subject
                            data['vehicle'] = true
                            data['notes'] = this.notes
                            data['multiple_accesses'] = true
                            data['typeInv'] = 2
                            data['companyFrom'] = ''
                            data['expiration'] = '2050-01-01'
                            data['exp'] = '2050-01-01'
                            data['diary'] = '0123456'
                            let host_cc_list = []
                            if (this.checkCC && this.hostCC.length > 0) {
                              for (let i = 0; i < this.hostCC.length; i++) {
                                host_cc_list.push(
                                    {
                                      "host_cc": this.hostCC[i]
                                    }
                                )
                              }
                              data['host_cc'] = host_cc_list
                            } else {
                              data['host_cc'] = null
                              this.hostCC = []
                            }
                            console.log('Documentation = ', this.documentos)
                            let dataToSend = {}
                            if (this.documentos.length > 0) {
                                console.log('Entro a Documentacion')
                                data['documentation'] = this.documentos
                            }
                            if (this.band_vip_invitacion) {
                                dataToSend = data
                            } else {
                                if (this.documentos.length > 0) {
                                    dataToSend = {
                                        guests: this.guests,
                                        cellNumber: this.cellNumber,
                                        areaId: this.areaId,
                                        dateInv: this.dateInv,
                                        timeInv: this.hora,
                                        subject: this.subject,
                                        vehicle: this.vehicle,
                                        notes: this.notes,
                                        multiple_accesses: this.multiple_accesses,
                                        companyFrom: this.companyFrom,
                                        exp: fecha_expiracion,
                                        expiration: fecha_expiracion,
                                        diary: dias_semana,
                                        typeInv: tipo_invitacion,
                                        host_cc: host_cc_list.length > 0 ? host_cc_list : null,
                                        documentation: this.documentos
                                    }
                                } else {
                                    dataToSend = {
                                        guests: this.guests,
                                        cellNumber: this.cellNumber,
                                        areaId: this.areaId,
                                        dateInv: this.dateInv,
                                        timeInv: this.hora,
                                        subject: this.subject,
                                        vehicle: this.vehicle,
                                        notes: this.notes,
                                        multiple_accesses: this.multiple_accesses,
                                        companyFrom: this.companyFrom,
                                        exp: fecha_expiracion,
                                        expiration: fecha_expiracion,
                                        diary: dias_semana,
                                        typeInv: tipo_invitacion,
                                        host_cc: host_cc_list.length > 0 ? host_cc_list : null
                                    }
                                }
                            }
                            const config = {
                                method: 'post',
                                url: this.getProfile.roll !== 4 ? 'https://empresa-service.intrare.app/create_inv/' : 'https://empresa-service.intrare.app/InvitationPark/create/',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': this.language,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: dataToSend
                            };
                            axios(config)
                                .then(ok => {
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                    // this.get_equipment()
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                    this.loading = false
                                })
                                .catch(error => {
                                    if (error.response.status == 400 && typeof error.response.data == "object" && error.response.data){
                                        this.errores = error.response.data
                                        console.log(error.response.data)
                                        if(error.response.data.exp)
                                            this.errores.expiration = error.response.data.exp
                                        console.log(error.response.data.Error)
                                        if(error.response.data.Error) {
                                          this.loading = false
                                          this.msgError = error.response.data.Error
                                          this.dialogMsgError = true
                                        }
                                    }
                                    if (error.response.status === 401) {
                                        this.dialogNopay = true
                                        console.log('No ha pagado el Servico')
                                    }
                                    this.loading = false
                                })
                        }
                    }).catch((e) => {
                        console.log(e);// Failed
                    });
                }
            },
            get_name_company(){
                // console.log('VALOR DE CAMPO = ', this.id_empresa_empresarial)
                for(var i = 0 ; i < this.entries2.length ; i++){
                    if(this.entries2[i].id === this.id_empresa_empresarial){
                        // console.log('NAME COMPANY = ', this.entries2[i].name)
                        return this.entries2[i].name
                    }
                }
            },
            alta_invitacion_empresarial: function () {
                if(this.band_invitacion_recurrente && this.at_least_one_day() === 0) {
                    this.dialog_at_least_one_day = true
                }
                else{
                    this.loading = true
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.errores = []
                            var company_name = this.get_name_company()
                            var data = {}
                            if (this.band_invitacion_recurrente) {
                                this.get_days()
                                data['referredMail'] = this.admin === undefined ? '' : this.admin.email
                                data['id_empresa'] = this.id_empresa_empresarial
                                data['areaId'] = this.areaId
                                data['dateInv'] = this.dateInv
                                data['timeInv'] = this.hora
                                data['subject'] = this.subject
                                data['vehicle'] = this.vehicle
                                data['multiple_accesses'] = this.multiple_accesses
                                data['notes'] = this.notes
                                data['companyFrom'] = company_name
                                data['typeInv'] = 2
                                data['expiration'] = this.diary
                                data['diary'] = this.dias
                            } else {
                                data['referredMail'] = this.admin === undefined ? '' : this.admin.email
                                data['id_empresa'] = this.id_empresa_empresarial
                                data['areaId'] = this.areaId
                                data['dateInv'] = this.dateInv
                                data['timeInv'] = this.hora
                                data['subject'] = this.subject
                                data['vehicle'] = this.vehicle
                                data['multiple_accesses'] = this.multiple_accesses
                                data['notes'] = this.notes
                                data['companyFrom'] = company_name
                                data['typeInv'] = 0
                            }
                            if (this.documentos.length > 0) {
                                data['documentation'] = this.documentos
                            }
                            const config = {
                                method: 'post',
                                url: (this.getProfile.roll === 5 || this.getProfile.roll === 1) ? 'https://empresa-service.intrare.app/createReferredInv' : 'https://empresa-service.intrare.app/InvitationPark/referredInvitation/',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': this.language,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: (this.getProfile.roll === 5 || this.getProfile.roll === 1) ?
                                    data
                                    : {
                                        invitation: {
                                            dateInv: this.dateInv,
                                            vehicle: this.vehicle,
                                            timeInv: this.hora,
                                            expiration: this.dateInv,
                                            subject: this.subject,
                                            notes: this.notes,
                                        },
                                        referredMail: this.admin === undefined ? '' : this.admin.email,
                                        referredPhone: this.admin === undefined ? '' : this.admin.celular
                                    }
                            };
                            axios(config)
                                .then(ok => {
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
                                    // this.get_equipment()
                                    this.dialog = false
                                    setTimeout(this.clear, 3000);
                                    this.loading = false
                                })
                                .catch(error => {
                                    if (error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data) {
                                        if (error.response.data.invitation !== undefined) {
                                            if (error.response.data.invitation.dateInv)
                                                this.errores.dateInv = error.response.data.invitation.dateInv
                                            if (error.response.data.invitation.timeInv)
                                                this.errores.timeInv = error.response.data.invitation.timeInv
                                            if (error.response.data.invitation.vehicle)
                                                this.errores.vehicle = error.response.data.invitation.vehicle
                                            if (error.response.data.invitation.subject)
                                                this.errores.subject = error.response.data.invitation.subject
                                            if (error.response.data.referredMail !== undefined) {
                                                if (error.response.data.referredMail)
                                                    this.errores.referredMail = error.response.data.referredMail
                                            }
                                        } else {
                                            this.errores = error.response.data
                                        }
                                    }
                                    if (error.response.status === 401) {
                                        this.dialogNopay = true
                                        console.log('No ha pagado el Servico')
                                    }
                                    this.loading = false
                                })
                        }
                    }).catch((e) => {
                        console.log(e);// Failed
                    });
                }
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.clean_fields()
            },
            fill_fields(item){
                this.nombre = item.nombre
                this.activa = item.activa
            },
            clean_fields(){
                this.documentos = []
                this.email = []
                this.cellNumber = ''
                this.areaId = ''
                this.dateInv= ''
                this.timeInv = ''
                this.subject = ''
                this.secEquip = ''
                this.vehicle = ''
                this.notes = ''
                this.multiple_accesses = false
                this.companyFrom = ''
                // Campos Invitacion Empresarial
                this.administradores = []
                this.id_empresa_empresarial = []
                this.admin = {}
                this.bandSinAdministrador = false
            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            customFilterUsersLessMe (item, queryText) {
              const textOne = item.first_name.toLowerCase()
              const textTwo = item.last_name.toLowerCase()
              const textThree = item.email.toLowerCase()
              const searchText = queryText.toLowerCase()
              return textOne.indexOf(searchText) > -1
                  || textTwo.indexOf(searchText) > -1
                  || textThree.indexOf(searchText) > -1

            },
            customFilterAdministradores (item, queryText) {
                const textOne = item.email.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            getIndexOfGuest (arr, item) {
                let index = -1;
                let band = false
                for (let i = 0 ; i < arr.length && !band; i++) {
                    if (arr[i].celular === item.celular || arr[i].email === item.email) {
                        index = i
                      band = true
                    }
                }
                return index
            },
            remove: function(item) {
                console.log(item.celular)
                const index = this.getIndexOfGuest(this.email, item)
                console.log('Index of = ', index)
                if (index >= 0) this.email.splice(index, 1)
            },
            get_managerByCompany: function(id_company){
                console.log(id_company)
                if (id_company !== null && id_company !== undefined) {
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/empresas/administradoresByCompany/' + id_company,
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            if (response.data.length === 0) {
                                this.admin = {}
                                this.bandSinAdministrador = true
                            } else {
                                this.bandSinAdministrador = false
                            }
                            this.administradores = response.data
                        })
                        .catch(error => {
                            console.log(error)
                        })
                } else {
                    this.admin = {}
                    this.administradores = []
                    this.bandSinAdministrador = false
                }
            },
            changeCheck (e){
                if (this.band_invitacion_empresarial === true){
                    if (this.getProfile.roll === 4) {
                        this.band_invitacion_recurrente = false
                    }
                    this.checkCC = false
                    this.hostCC = []
                }
            },
            changeCheck2 (e){
                if (this.band_vip_invitacion === true){
                    this.band_invitacion_recurrente = false
                    this.band_invitacion_empresarial = false
                }
            },
            fullNamePlusCellphone: item => item.email + ' ' + item.celular + ' ' + item.first_name + ' ' + item.last_name,
            celularAndEmail: item => item.email + ' ' + item.celular
        }
    }
</script>

<style scoped>

</style>
